import axios from 'axios'
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from '../store'
import Vue from 'vue'

import applicationUserManager from '../Auth/applicationusermanager'

let base = ''
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';

// 请求延时
axios.defaults.timeout = 300000

var storeTemp = store
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date()
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

    if (storeTemp.state.token && curTime < expiretime && storeTemp.state.tokenExpire) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = 'Bearer ' + storeTemp.state.token
    }

    saveRefreshtime()

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // 判断Bolb类型是否有错误信息
    if (response.data instanceof Blob && response.data.type === 'application/json') {
      console.log('Blob类型有错误信息')
      let reader = new FileReader()
      reader.readAsText(response.data, 'utf-8')
      reader.onload = function (e) {
        let data = JSON.parse(e.target.result)
        if (data.code == 400) {
          Vue.prototype.$message({
            message: data.msg,
            type: 'error',
          })
        }
      }
      return response
    }
    return response
  },
  (error) => {
    console.log('error', error)
    let errInfo = { success: false, message: '错误' }
    // 超时请求处理
    var originalRequest = error.config
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
      errInfo.message = '请求超时！'
      originalRequest._retry = true
    } else if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({ token: window.localStorage.Token }).then((res) => {
            if (res.success) {
              Vue.prototype.$message({
                message: 'refreshToken success! loading data...',
                type: 'success',
              })

              store.commit('saveToken', res.response.token)

              var curTime = new Date()
              var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in))
              store.commit('saveTokenExpire', expiredate)

              error.config.__isRetryRequest = true
              error.config.headers.Authorization = 'Bearer ' + res.response.token
              return axios(error.config)
            } else {
              // 刷新token失败 清除token信息并跳转到登录页面
              ToLogin()
            }
          })
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }
        errInfo.message = '失败！验证失效，请重新登录'
      }
      // 403 无权限
      else if (error.response.status == 403) {
        errInfo.message = '失败！该操作无权限'
      }
      // 429 ip限流
      else if (error.response.status == 429) {
        errInfo.message = '刷新次数过多，请稍事休息重试！'
      } else if (error.response.status == 404) {
        // 404 不存在
        errInfo.message = '失败！访问接口不存在'
      } else if (error.response.status == 500) {
        // 500 服务器异常
        errInfo.message = '失败！服务器异常'
      } else if (error.response.status == 405) {
        // 405 请求http方法错误
        errInfo.message = '失败！请求http方法错误'
      } else if (error.response.status == 415) {
        // 415 参数没有指定Body还是Query
        errInfo.message = '失败！参数没有指定Body还是Query'
      } else {
        //其他错误参数
        errInfo.message = '失败！请求错误' + error.response.status
      }
    } else {
      // errInfo.message = "失败！服务器断开";
      return
    }
    Vue.prototype.$message({
      message: errInfo.message,
      type: 'error',
    })
    return errInfo // 返回接口返回的错误信息
  }
)

export const BaseApiUrl = base

// 登录
export const requestLogin = (params) => {
  return axios.get(`${base}/api/login/jwttoken3.0`, { params: params }).then((res) => res.data)
}
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data)
}

export const refreshToken = (params) => {
  return axios.get(`${base}/api/login/RefreshToken`, { params: params }).then((res) => res.data)
}

export const saveRefreshtime = (params) => {
  let nowtime = new Date()
  let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1)
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1 //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount)
    window.localStorage.refreshtime = lastRefreshtime
  } else {
    window.localStorage.refreshtime = new Date(-1)
  }
}
const ToLogin = (params) => {
  store.commit('saveToken', '')
  store.commit('saveTokenExpire', '')
  store.commit('saveTagsData', '')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('NavigationBar')

  if (global.IS_IDS4) {
    applicationUserManager.login()
  } else {
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.fullPath },
    })
    //window.location.reload()
  }
}

export const getUserByToken = (params) => {
  return axios.get(`${base}/api/user/getInfoByToken`, { params: params }).then((res) => res.data)
}

export function testapi2() {
  console.log('api is ok.')
}

export const testapi = (pa) => {
  console.log('api is ok.')
}

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params })
}
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params })
}
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params)
}
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params)
}
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }) //没做
}

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params })
}
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params })
}
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params)
}
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params)
}

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params })
}
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params })
}
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params)
}
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params)
}

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params })
}
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params })
}
export const migratePermissionTable = (params) => {
  return axios.get(`${base}/api/permission/MigratePermission`, { params: params })
}
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params })
}
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params)
}
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params)
}
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, { params: params })
}
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, { params: params })
}

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params)
}
export const getNavigationBar = (params) => {
  return axios.get(`${base}/api/permission/GetNavigationBar`, { params: params }).then((res) => res.data)
}

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params })
}
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params })
}
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params)
}
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params)
}

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params })
}
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params })
}
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params)
}
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params })
}

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params })
}
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, { params: params })
}
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, { params: params })
}
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, { params: params })
}
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params })
}
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params })
}
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params })
}
export const getActiveUsers = (params) => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params })
}

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params })
}
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params })
}
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params)
}
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params)
}

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params })
}
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params })
}
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params })
}
export const pauseJob = (params) => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params })
}
export const resumeJob = (params) => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params })
}
export const getTaskNameSpace = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params })
}
export const GetTaskLogs = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskLogs`, { params: params })
}
export const GetTaskOverview = (params) => {
  return axios.get(`${base}/api/TasksQz/GetTaskOverview`, { params: params })
}
// ids4
export const getAchieveUsers_IS4 = (params) => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params })
}

//微信公众号
export const getWeChatAccount = (params) => {
  return axios.get(`${base}/api/WeChatConfig/get`, { params: params })
}
export const removeWeChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/delete`, { params: params })
}
export const batchDeleteChatAccount = (params) => {
  return axios.delete(`${base}/api/WeChatConfig/BatchDelete`, { params: params })
}
export const addWeChatAccount = (params) => {
  return axios.post(`${base}/api/WeChatConfig/post`, params)
}
export const updateWeChatAccount = (params) => {
  return axios.put(`${base}/api/WeChatConfig/put`, params)
}
export const getWeChatTemplate = (params) => {
  return axios.get(`${base}/api/WeChat/GetTemplate`, { params: params }) //获取模板
}
export const refreshWeChatToken = (params) => {
  return axios.get(`${base}/api/WeChat/RefreshToken`, { params: params }) //更新Token
}
export const getWeChatMenu = (params) => {
  return axios.get(`${base}/api/WeChat/GetMenu`, { params: params }) //获取微信菜单
}
export const updateWeChatMenu = (params) => {
  return axios.put(`${base}/api/WeChat/updateMenu`, params) //更新微信菜单
}
export const getWeChatCompany = (params) => {
  return axios.get(`${base}/api/WeChatCompany/get`, { params: params })
}
export const removeWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/delete`, { params: params })
}
export const batchDeleteWeChatCompany = (params) => {
  return axios.delete(`${base}/api/WeChatCompany/BatchDelete`, { params: params })
}
export const addWeWeChatCompany = (params) => {
  return axios.post(`${base}/api/WeChatCompany/post`, params)
}
export const updateWeChatCompany = (params) => {
  return axios.put(`${base}/api/WeChatCompany/put`, params)
}
export const getWeChatPushLog = (params) => {
  return axios.get(`${base}/api/WeChatPushLog/get`, { params: params })
}
export const getWeChatSubUser = (params) => {
  return axios.get(`${base}/api/WeChat/GetSubUsers`, { params: params })
}
export const getWeChatBindUser = (params) => {
  return axios.get(`${base}/api/WeChatSub/get`, { params: params })
}
export const pushTestMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushTxtMsg`, params)
}
export const pushCardMsg = (params) => {
  return axios.post(`${base}/api/WeChat/PushCardMsg`, params)
}

// 部门模块管理
export const getDepartmentListPage = (params) => {
  return axios.get(`${base}/api/department/get`, { params: params })
}
export const getDepartmentTreeTable = (params) => {
  return axios.get(`${base}/api/department/getTreeTable`, { params: params })
}

export const removeDepartment = (params) => {
  return axios.delete(`${base}/api/department/delete`, { params: params })
}
export const editDepartment = (params) => {
  return axios.put(`${base}/api/department/put`, params)
}
export const addDepartment = (params) => {
  return axios.post(`${base}/api/department/post`, params)
}
export const getDepartmentTree = (params) => {
  // return axios.get(`${base}/api/department/getDepartmentTree`, {params: params});
}

// HCO
export const HcoQueryPage = (params) => {
  return axios.get(`${base}/api/Hco/QueryPage`, { params: params })
}

export const HcoGetByid = (params) => {
  return axios.get(`${base}/api/Hco/GetByid`, { params: params })
}

export const HcoGetHcoinfoApproval = (params) => {
  return axios.get(`${base}/api/Hco/GetHcoinfoApproval`, { params: params })
}

export const HcoGetHcoinfoApprovalNO = (params) => {
  return axios.get(`${base}/api/Hco/GetHcoinfoApprovalNO`, { params: params })
}

export const HcoAddHCO = (params) => {
  return axios.post(`${base}/api/Hco/AddHCO`, params)
}

export const HcoUpdataHCO = (params) => {
  return axios.put(`${base}/api/Hco/UpdataHCO`, params)
}

export const HcoApproval = (params) => {
  return axios.post(`${base}/api/Hco/Approval`, params)
}

export const approval_request_Approval_Claim = (params) => {
  return axios.post(`${base}/api/approval_request/Approval_Claim`, params)
}

export const HcoApprovalCancel = (params) => {
  return axios.post(`${base}/api/Hco/ApprovalCancel`, params)
}

export const HcoHcoExportExcel = (params) => {
  return axios.post(`${base}/api/Hco/HcoExportExcel`, params)
}

export const HcoHcoInfoExportExcel = (params) => {
  return axios.get(`${base}/api/Hco/HcoInfoExportExcel`, { params: params })
}

export const HcoQueryByStr = (params) => {
  return axios.get(`${base}/api/Hco/QueryByStr`, { params: params })
}

export const HcoImprotUpdateList = (params) => {
  return axios.post(`${base}/api/Hco/ImprotUpdateList`, params)
}

export const HcoUpdataHCOTagInfo = (params) => {
  return axios.put(`${base}/api/Hco/UpdataHCOTagInfo`, params)
}

export const HcoUpdateVersionLogsGetEffectiveDateList = (params) => {
  return axios.get(`${base}/api/HcoUpdateVersionLogs/GetEffectiveDateList`, { params: params })
}

export const HcoGetHcoCatGroup = (params) => {
  return axios.get(`${base}/api/Hco/GetHcoCatGroup`, { params: params })
}

export const HcoGetHcoRefGroup = (params) => {
  return axios.get(`${base}/api/Hco/GetHcoRefGroup`, { params: params })
}

export const HcoGetVersionList = (params) => {
  return axios.get(`${base}/api/Hco/GetVersionList`, { params: params })
}

export const EmployeeUpdateVersionLogsGetEffectiveDateList = (params) => {
  return axios.get(`${base}/api/EmployeeUpdateVersionLogs/GetEffectiveDateList`, { params: params })
}

export const GetHcoinfoApprovalNOExportExcel = (params) => {
  return axios.get(`${base}/api/Hco/GetHcoinfoApprovalNOExportExcel`, { params: params })
}

// HCP

export const HcpApprovalCancel = (params) => {
  return axios.post(`${base}/api/Hcp/ApprovalCancel`, params)
}

export const HcpQueryPage = (params) => {
  return axios.get(`${base}/api/Hcp/QueryPage`, { params: params })
}

export const HcpGetHcpinfoApproval = (params) => {
  return axios.get(`${base}/api/Hcp/GetHcpinfoApproval`, { params: params })
}

export const HcpGetHcpinfoApprovalNO = (params) => {
  return axios.get(`${base}/api/Hcp/GetHcpinfoApprovalNO`, { params: params })
}

export const HcpGetByid = (params) => {
  return axios.get(`${base}/api/Hcp/GetByid`, { params: params })
}

export const HcpAddHCP = (params) => {
  return axios.post(`${base}/api/Hcp/AddHCP`, params)
}

export const HcpUpdataHCP = (params) => {
  return axios.put(`${base}/api/Hcp/UpdataHCP`, params)
}

export const HcpApproval = (params) => {
  return axios.post(`${base}/api/Hcp/Approval`, params)
}

export const HcpGetSpeakerIndexLists = (params) => {
  return axios.get(`${base}/api/Hcp/GetSpeakerIndexLists`, { params: params })
}

// export const HcpComputeScore = params => {
//     return axios.get(`${base}/api/Hcp/ComputeScore`, {params: params});
// };
export const HcpComputeScore = (params) => {
  return axios.post(`${base}/api/Hcp/ComputeScore`, params)
}

export const HcpHcpExportExcel = (params) => {
  return axios.post(`${base}/api/Hcp/HcpExportExcel`, params)
}

export const HcpQueryList = (params) => {
  return axios.get(`${base}/api/Hcp/QueryList`, { params: params })
}

export const HcpInformedConsent = (params) => {
  return axios.post(`${base}/api/Hcp/InformedConsent`, params)
}

export const HcoQueryNameByStr = (params) => {
  return axios.get(`${base}/api/Hco/QueryNameByStr`, { params: params })
}

export const HcpGetTitleList = (params) => {
  return axios.get(`${base}/api/Hcp/GetTitleList`, { params: params })
}

// approval_request
// 审批

export const approval_requestGetApprovalInfoByID = (params) => {
  // return axios.get(`${base}/api/approval_request/GetApprovalInfoByID`, {params: params});
  return axios.get(`${base}/api/approval_request/GetApprovalInfoByIDTag`, { params: params })
}

export const approval_GetApprovalInfoByIDTag_Claim = (params) => {
  // return axios.get(`${base}/api/approval_request/GetApprovalInfoByID`, {params: params});
  return axios.get(`${base}/api/approval_request/GetApprovalInfoByIDTag_Claim`, { params: params })
}

// Flow审批流管理
export const Flow_GetPage = (params) => {
  return axios.get(`${base}/api/Flow/GetPage`, { params: params })
}

export const Flow_GetFlowDataInfoByID = (params) => {
  return axios.get(`${base}/api/Flow/GetFlowDataInfoByID`, { params: params })
}

export const Flow_GetFlowSelectOptions = (params) => {
  return axios.get(`${base}/api/Flow/GetFlowSelectOptions`, { params: params })
}

export const FlowUpdateFlowInfo = (params) => {
  return axios.post(`${base}/api/Flow/UpdateFlowInfo`, params)
}

// Employee 雇员信息

export const Employee_GetByid = (params) => {
  return axios.get(`${base}/api/Employee/GetByid`, { params: params })
}
export const Employee_QueryPage = (params) => {
  return axios.get(`${base}/api/Employee/QueryPage`, { params: params })
}
export const EmployeeUpdateEmplovee = (params) => {
  return axios.post(`${base}/api/Employee/UpdateEmployee`, params)
}
export const Employee_QueryById = (params) => {
  return axios.get(`${base}/api/Employee/QueryById`, { params: params })
}

export const Employee_GetCurrentEmployee = (params) => {
  return axios.get(`${base}/api/Employee/GetCurrentEmployee`, { params: params })
}

export const EmployeeImprotUpdateList = (params) => {
  return axios.post(`${base}/api/Employee/ImprotUpdateList`, params)
}
export const Employee_GetList = (params) => {
  return axios.get(`${base}/api/Employee/GetList`, { params: params })
}

export const EmployeePosition_ImportPosition = (params) => {
  return axios.post(`${base}/api/EmployeePosition/ImportPosition`, params)
}

export const Employee_EmployeeExportExcel = (params) => {
  return axios.get(`${base}/api/Employee/EmployeeExportExcel`, { params: params })
}

// export const EmployeePosition_EmployeePositionExportExcel = params => {
//     return axios.get(`${base}/api/EmployeePosition/EmployeePositionExportExcel`, {params: params});
// };
export const EmployeePosition_EmployeePositionExportExcel = (params) => {
  return axios.post(`${base}/api/EmployeePosition/EmployeePositionExportExcel`, params)
}

// EmployeePosition
// 销售岗位
export const EmployeePosition_QueryList = (params) => {
  return axios.get(`${base}/api/EmployeePosition/QueryList`, { params: params })
}

export const EmployeePosition_QueryPage = (params) => {
  return axios.get(`${base}/api/EmployeePosition/QueryPage`, { params: params })
}

export const EmployeePositionUpdate = (params) => {
  return axios.post(`${base}/api/EmployeePosition/Update`, params)
}

export const EmployeePositionAddEmployeePosition = (params) => {
  return axios.post(`${base}/api/EmployeePosition/AddEmployeePosition`, params)
}

// 省市
export const regionGetRegionTree = (params) => {
  return axios.get(`${base}/api/region/GetRegionTree`, { params: params })
}

// 医院科室
export const DepartmentsGetDepartmentsTree = (params) => {
  return axios.get(`${base}/api/Departments/GetDepartmentsTree`, { params: params })
}
// Msg
export const MsgQueryPage = (params) => {
  return axios.get(`${base}/api/Msg/QueryPage`, { params: params })
}
export const MsgGetHcoAndHcpCount = (params) => {
  return axios.get(`${base}/api/Msg/GetHcoAndHcpCount`, { params: params })
}

export const MsgDeleteById = (params) => {
  return axios.delete(`${base}/api/Msg/DeleteById`, { params: params })
}

export const MsgDisableById = (params) => {
  return axios.post(`${base}/api/Msg/DisableById`, params)
}

// Departments
// 医院科室

export const DepartmentsQueryPage = (params) => {
  return axios.get(`${base}/api/Departments/GetDepartmentsTree`, { params: params })
}

// EmployeeRegion
// 销售区域

export const EmployeeRegionGetEmployeeRegionTrees = (params) => {
  return axios.get(`${base}/api/EmployeeRegion/GetEmployeeRegionTrees`, { params: params })
}

export const EmployeeRegionAdd = (params) => {
  return axios.post(`${base}/api/EmployeeRegion/Add`, params)
}

export const EmployeeRegionUpdate = (params) => {
  return axios.post(`${base}/api/EmployeeRegion/Update`, params)
}

// EmailTemplate
// 邮件模板

export const EmailTemplateAdd = (params) => {
  return axios.post(`${base}/api/EmailTemplate/Add`, params)
}

export const EmailTemplateUpdate = (params) => {
  return axios.post(`${base}/api/EmailTemplate/Update`, params)
}

export const EmailTemplateQueryPage = (params) => {
  return axios.get(`${base}/api/EmailTemplate/QueryPage`, { params: params })
}

export const LoginGetJwtTokensso = (params) => {
  return axios.get(`${base}/api/Login/GetJwtTokensso`, { params: params })
}

// Msg
// 通知管理

export const MsgAddMsg = (params) => {
  return axios.post(`${base}/api/Msg/AddMsg`, params)
}

export const MsgUpdateMsg = (params) => {
  return axios.post(`${base}/api/Msg/UpdateMsg`, params)
}

export const MsgGetPVUV = (params) => {
  return axios.get(`${base}/api/Msg/GetPVUV`, { params: params })
}

export const MsgGetMsgApprovalList = (params) => {
  return axios.get(`${base}/api/Msg/GetMsgApprovalList`, { params: params })
}

export const EmployeeUpdateVersionLogsExportVersion = (params) => {
  return axios.get(`${base}/api/EmployeeUpdateVersionLogs/ExportVersion`, { params: params })
}

export const HcoUpdateVersionLogsExportVersion = (params) => {
  return axios.get(`${base}/api/HcoUpdateVersionLogs/ExportVersion`, { params: params })
}

export const EmployeeGetVersionArr = (params) => {
  return axios.get(`${base}/api/Employee/GetVersionArr`, { params: params })
}

// 经销商
export const DealerQueryPage = (params) => {
  return axios.get(`${base}/api/DealerMasterData/QueryPage`, { params: params })
}
export const QueryDealerHospitalRelationPage = (params) => {
  return axios.get(`${base}/api/DealerMasterData/QueryDealerHospitalRelationPage`, { params: params })
}

// 产品
export const ProductInfoGetPageList = (params) => {
  return axios.get(`${base}/api/ProductInfo/GetPageList`, { params: params })
}

export const DealerMasterDataDealerExportExcel = (params) => {
  return axios.get(`${base}/api/DealerMasterData/DealerExportExcel`, { params: params })
}

export const DealerMasterDataDealerHospitalRelationExportExcel = (params) => {
  return axios.get(`${base}/api/DealerMasterData/DealerHospitalRelationExportExcel`, { params: params })
}

export const ProductInfoGetExportExcel = (params) => {
  return axios.get(`${base}/api/ProductInfo/GetExportExcel`, { params: params })
}

export const EmployeeUpdateEmployeeLevel = (params) => {
  return axios.post(`${base}/api/Employee/UpdateEmployeeLevel`, params)
}

export const EmployeeQueryPage_Claim = (params) => {
  return axios.get(`${base}/api/Employee/QueryPage_Claim`, { params: params })
}

export const EmployeeQueryPage_Release = (params) => {
  return axios.get(`${base}/api/Employee/QueryPage_Release`, { params: params })
}

export const EmployeeUpdateEmployee_Release = (params) => {
  return axios.post(`${base}/api/Employee/Employee_Release`, params)
}

export const EmployeeUpdatePosition_Claimed = (params) => {
  return axios.post(`${base}/api/Employee/Position_Claimed`, params)
}

export const Hco_QueryPage_Release = (params) => {
  return axios.get(`${base}/api/Hco/QueryPage_Release`, { params: params })
}

export const Employee_GetPosition_ClaimApprovalNO = (params) => {
  return axios.get(`${base}/api/Employee/GetPosition_ClaimApprovalNO`, { params: params })
}

export const Hco_hco_release = (params) => {
  return axios.post(`${base}/api/Hco/hco_release`, params)
}
export const Employee_Position_Update = (params) => {
  return axios.post(`${base}/api/Employee/Position_Update`, params)
}
export const Employee_Query_Claim_byid = (params) => {
  return axios.get(`${base}/api/Employee/Query_Claim_byid`, { params: params })
}

export const Hco_QueryPage_Claim = (params) => {
  return axios.get(`${base}/api/Hco/QueryPage_Claim`, { params: params })
}

export const Employee_Query_Claim_Requre = (params) => {
  return axios.get(`${base}/api/Employee/Query_Claim_Requre`, { params: params })
}
// export const Employee_Position_Update = (params) => {
//   return axios.post(`${base}/api/Employee/Position_Update`, params)
// }
export const approval_request_ApprovalCancel = (params) => {
  return axios.post(`${base}/api/approval_request/ApprovalCancel`, params)
}

// NVBP
export const extapi_dashboard_get = (params) => {
  return axios.get(`${base}/extapi/dashboard/get`, { params: params })
}
export const cataractnnvmp_getlist = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getlist`, { params: params })
}
export const cataractnnvmp_getjjsvproduct = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getjjsvproduct`, { params: params })
}
export const cataractnnvmp_getmarketproduct = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getmarketproduct`, { params: params })
}
export const cataractnnvmp_getapprovals = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getapprovals`, { params: params })
}
export const cataractnnvmp_approvalspending = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/approvalspending`, { params: params })
}
export const cataractnnvmp_getapplyapprovals = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getapplyapprovals`, { params: params })
}
export const cataractnnvmp_submit = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/submit`, params)
}
export const cataractnnvmp_approvalclaim = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/approvalclaim`, params)
}

export const cataractnnvmp_exportdata = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/exportdata`, params, { responseType: 'blob', body: 'form-data' })
}

// export const cataractnnvmp_mobilesubmit = (params) => {
//   return axios.post(`${base}/extapi/cataractnnvmp/mobilesubmit`, params)
// }

export const cataractnnvmp_approvalcancel = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/approvalcancel`, params)
}

export const expend_getlist = (params) => {
  return axios.get(`${base}/extapi/expend/getlist`, { params: params })
}

export const expend_submitestimate = (params) => {
  return axios.post(`${base}/extapi/expend/submit`, params)
}

export const expend_exportdata = (params) => {
  return axios.post(`${base}/extapi/expend/exportdata`, params, { responseType: 'blob', body: 'form-data' })
}

export const estimate_getlist = (params) => {
  return axios.get(`${base}/extapi/estimate/getlist`, { params: params })
}

export const cataractnnvmp_mobiledetailed = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/mobiledetailed`, { params: params })
}

export const estimate_submitestimate = (params) => {
  return axios.post(`${base}/extapi/estimate/submitestimate`, params)
}

export const estimate_exportdata = (params) => {
  return axios.post(`${base}/extapi/estimate/exportdata`, params, { responseType: 'blob', body: 'form-data' })
}
export const cataractnnvmp_mobilesubmit2 = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/mobilesubmit2`, params)
}
export const cataractnnvmp_downloadtemplatefile = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/downloadtemplatefile/ims`, params, { responseType: 'blob', body: 'form-data' })
}

export const cataractnnvmp_gethospitalinfo = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/gethospitalinfo`, { params: params })
}
export const estimate_getsubmissionsummary = (params) => {
  return axios.get(`${base}/extapi/estimate/getsubmissionsummary`, { params: params })
}
export const cataractnnvmp_hospitalinfosubmit = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/hospitalinfosubmit`, params)
}
export const estimate_submissionsummary = (params) => {
  return axios.post(`${base}/extapi/estimate/submissionsummary`, params)
}

export const dashboard_analysis = (params) => {
  return axios.get(`${base}/extapi/dashboard/analysis`, { params: params })
}

export const dashboard_getachievementrate = (params) => {
  return axios.get(`${base}/extapi/dashboard/getachievementrate`, { params: params })
}

export const dashboard_getmonthlystackeddata = (params) => {
  return axios.get(`${base}/extapi/dashboard/getmonthlystackeddata`, { params: params })
}
export const dashboard_getmonthlyaverageimplantdata = (params) => {
  return axios.get(`${base}/extapi/dashboard/getmonthlyaverageimplantdata`, { params: params })
}
export const dashboard_getweeklysharedata = (params) => {
  return axios.get(`${base}/extapi/dashboard/getmonthlysharedata`, { params: params })
}
export const dashboard_getmonthlygrowthpercentage = (params) => {
  return axios.get(`${base}/extapi/dashboard/getmonthlygrowthpercentage`, { params: params })
}
export const dashboard_getproductpercentage = (params) => {
  return axios.get(`${base}/extapi/dashboard/getproductpercentage`, { params: params })
}
export const dashboard_getproductgroupaccuracy = (params) => {
  return axios.get(`${base}/extapi/dashboard/getproductgroupaccuracy`, { params: params })
}
export const dashboard_getcontractprogress = (params) => {
  return axios.get(`${base}/extapi/dashboard/getcontractprogress`, { params: params })
}
export const expend_getcurrentmonthandtodayquotadata = (params) => {
  return axios.get(`${base}/extapi/expend/getcurrentmonthandtodayquotadata`, { params: params })
}
export const expend_getmanagedhospitals = (params) => {
  return axios.get(`${base}/extapi/expend/getmanagedhospitals`, { params: params })
}
export const dashboard_getregionsbylevel = (params) => {
  return axios.get(`${base}/extapi/dashboard/getregionsbylevel`, { params: params })
}
export const cataractnnvmp_mobilesubmit = (params, queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString()
  const urlWithParams = `${base}/extapi/cataractnnvmp/mobilesubmit?${queryString}`
  return axios.post(urlWithParams, params)
}

// 获取角色
export const system_getcurrentuserrole = (params) => {
  return axios.get(`${base}/extapi/system/getcurrentuserrole`, { params: params })
}

// 小区经理
export const system_getsaleslistundersubregionmanager = (params) => {
  return axios.get(`${base}/extapi/system/getsaleslistundersubregionmanager`, { params: params })
}

// 大区经理
export const system_getsubregionlistunderregionmanager = (params) => {
  return axios.get(`${base}/extapi/system/getsubregionlistunderregionmanager`, { params: params })
}

// 产品线负责人
export const system_getregionlistunderproductlinemanager = (params) => {
  return axios.get(`${base}/extapi/system/getregionlistunderproductlinemanager`, { params: params })
}

// 产品分组
export const expend_getdailyreportbyproduct = (params) => {
  return axios.get(`${base}/extapi/expend/getdailyreportbyproduct`, { params: params })
}

// 产品线负责人区域分组
export const expend_getdailyreportbyregion = (params) => {
  return axios.get(`${base}/extapi/expend/getdailyreportbyregion`, { params: params })
}

//大区经理区域分组
export const expend_getregionalmanagerdailyreport = (params) => {
  return axios.get(`${base}/extapi/expend/getregionalmanagerdailyreport`, { params: params })
}

// 小区经理区域分组
export const expend_getregionaldailyreport = (params) => {
  return axios.get(`${base}/extapi/expend/getregionaldailyreport`, { params: params })
}

export const system_getproductlistothers = (params) => {
  return axios.get(`${base}/extapi/system/getproductlistothers`, { params: params })
}

export const estimate_monthlyreportsummary = (params) => {
  return axios.get(`${base}/extapi/estimate/monthlyreportsummary`, { params: params })
}
// export const MsgQueryPage = params => {
//     return axios.get(`${base}/api/Msg/QueryPage`, {params: params});
// };

export const estimate_submitforreview = (params) => {
  return axios.post(`${base}/extapi/estimate/submitforreview`, params)
}

export const estimate_getsubordinateapprovalrecords = (params) => {
  return axios.get(`${base}/extapi/estimate/getsubordinateapprovalrecords`, { params: params })
}

export const estimate_approvesubordinatereport = (params) => {
  return axios.post(`${base}/extapi/estimate/approvesubordinatereport`, params)
}

export const cataractnnvmp_batchapprovalclaim = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/batchapprovalclaim`, params)
}

export const estimate_getapprovaldetails = (params) => {
  return axios.get(`${base}/extapi/estimate/getapprovaldetails`, { params: params })
}

export const estimate_getsdapprovaldetails = (params) => {
  return axios.get(`${base}/extapi/estimate/getsdapprovaldetails`, { params: params })
}

// 手术量数据
export const cataractnnvmp_getmonthlysurgerydata = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getmonthlysurgerydata`, { params: params })
}

export const cataractnnvmp_getmonthlysurgeryexport = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/getmonthlysurgeryexport`, params, { responseType: 'blob', body: 'form-data' })
}

// 日
export const expend_getdailyconsumptionlist = (params) => {
  return axios.get(`${base}/extapi/expend/getdailyconsumptionlist`, { params: params })
}
export const expend_getdailyconsumptionexport = (params) => {
  return axios.post(`${base}/extapi/expend/getdailyconsumptionexport`, params, { responseType: 'blob', body: 'form-data' })
}

// 月
export const estimate_getmonthlyconsumptionlist = (params) => {
  return axios.get(`${base}/extapi/estimate/getmonthlyconsumptionlist`, { params: params })
}
export const estimate_getmonthlyconsumptionexport = (params) => {
  return axios.post(`${base}/extapi/estimate/getmonthlyconsumptionexport`, params, { responseType: 'blob', body: 'form-data' })
}

// drgdip
export const basichospital_getbasichospitaldrgdiplist = (params) => {
  return axios.get(`${base}/extapi/basichospital/getbasichospitaldrgdiplist`, { params: params })
}
export const basichospital_getbasichospitaldrgdipexport = (params) => {
  return axios.post(`${base}/extapi/basichospital/getbasichospitaldrgdipexport`, params, { responseType: 'blob', body: 'form-data' })
}

// 医院基础
export const basichospital_gethospitalcontractdata = (params) => {
  return axios.get(`${base}/extapi/basichospital/gethospitalcontractdata`, { params: params })
}
export const basichospital_gethospitalcontractexport = (params) => {
  return axios.post(`${base}/extapi/basichospital/gethospitalcontractexport`, params, { responseType: 'blob', body: 'form-data' })
}

// 飞白数据
export const flacs_getflacsdata = (params) => {
  return axios.get(`${base}/extapi/flacs/getflacsdata`, { params: params })
}
export const flacs_getflacsdataexport = (params) => {
  return axios.post(`${base}/extapi/flacs/getflacsdataexport`, params, { responseType: 'blob', body: 'form-data' })
}


export const flacs_gethcodata = (params) => {
  return axios.get(`${base}/extapi/flacs/gethcodata`, { params: params })
}

export const flacs_createhco = (params) => {
  return axios.post(`${base}/extapi/flacs/createhco`, params)
}

export const flacs_edithco = (params) => {
  return axios.post(`${base}/extapi/flacs/edithco`, params)
}

export const flacs_deletehco = (params) => {
  return axios.post(`${base}/extapi/flacs/deletehco`, params)
}

export const flacs_getmtddata = (params) => {
  return axios.get(`${base}/extapi/flacs/getmtddata`, { params: params })
}

export const flacs_getsalemtddata = (params) => {
  return axios.get(`${base}/extapi/flacs/getsalemtddata`, { params: params })
}

export const usagereport_getytdusage_ytd = (params) => {
  return axios.get(`${base}/extapi/usagereport/getytdusage/ytd`, { params: params })
}

export const usagereport_getytdusage_mtd = (params) => {
  return axios.get(`${base}/extapi/usagereport/getmtdusage/mtd`, { params: params })
}

export const usagereport_getdailyusage_day = (params) => {
  return axios.get(`${base}/extapi/usagereport/getdailyusage/day`, { params: params })
}

// 模糊医院
export const usagereport_gethospitaldropdown = (params) => {
  return axios.get(`${base}/extapi/usagereport/gethospitaldropdown`, { params: params })
}

// 模糊集团
export const usagereport_getgroupnamedropdown = (params) => {
  return axios.get(`${base}/extapi/usagereport/getgroupnamedropdown`, { params: params })
}
// 模糊销售代表
export const usagereport_getsalesnamedropdown = (params) => {
  return axios.get(`${base}/extapi/usagereport/getsalesnamedropdown`, { params: params })
}

export const usagereport_getregionsbylevel = (params) => {
  return axios.get(`${base}/extapi/usagereport/getregionsbylevel`, { params: params })
}

export const ims_downloadtemplatefile = (params) => {
  return axios.post(`${base}/extapi/ims/downloadtemplatefile`, params, { responseType: 'blob', body: 'form-data' })
}

export const ims_getsalesvolumelist = (params) => {
  return axios.get(`${base}/extapi/ims/getsalesvolumelist`, { params: params })
}

// export const ims_exportsalesvolumetoexcel = (params) => {
//   return axios.get(`${base}/extapi/ims/exportsalesvolumetoexcel`, { params: params }, { responseType: 'blob', body: 'form-data' })
// }
export const ims_exportsalesvolumetoexcel = (params) => {
  return axios.post(`${base}/extapi/ims/exportsalesvolumetoexcel`, params, { responseType: 'blob', body: 'form-data' })
}

export const usagereport_getproductlistothers = (params) => {
  return axios.get(`${base}/extapi/usagereport/getproductlistothers`, { params: params })
}

export const estimate_getforecastexport = (params) => {
  return axios.post(`${base}/extapi/estimate/getforecastexport`, params, { responseType: 'blob', body: 'form-data' })
}

export const estimate_sendemail = (params) => {
  return axios.post(`${base}/extapi/estimate/sendemail`, params)
}

export const estimate_getsendemailstatus = (params) => {
  return axios.get(`${base}/extapi/estimate/getsendemailstatus`, { params: params })
}

// 查询代岗配置列表
export const getPositionReplacementList = (params) => {
  return axios.get(`${base}/extapi/ProxyPosition/GetPositionReplacementList`, { params: params })
}

// 创建代岗配置
export const createPositionReplacement = (params) => {
  return axios.post(`${base}/extapi/ProxyPosition/CreatePositionReplacement`, params)
}

// 启用/停用代岗配置
export const editPositionReplacement = (params) => {
  return axios.post(`${base}/extapi/ProxyPosition/EditPositionReplacement`, params)
}

export const cataractnnvmp_getmonth = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getmonth`, { params: params })
}

export const cataractnnvmplistmonthconfigs = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/listmonthconfigs`, { params: params })
}

export const cataractnnvmp_createmonthconfig = (params) => {
  return axios.post(`${base}/extapi/cataractnnvmp/createmonthconfig`, params)
}
export const getApprovalTreeBySd = (params) => {
  return axios.get(`${base}/extapi/Estimate/GetApprovalTreeBySd`, { params: params })
}

export const exportApprovalProgressToExcel = (params) => {
  return axios.get(`${base}/extapi/Estimate/ExportApprovalProgressToExcel`, { params: params, responseType: 'blob' })
}

export const cataractnnvmp_getlistv1 = (params) => {
  return axios.get(`${base}/extapi/cataractnnvmp/getlistv1`, { params: params })
}

export const Hcp_Get_HCPSource = (params) => {
  return axios.get(`${base}/api/Hcp/Get_HCPSource`, { params: params })
}
// 飞白代岗配置管理
export const getFlacsDelegateRelationList = (params) => {
  return axios.post(`${base}/extapi/flacsdelegaterelation/getlist`, params)
}

export const createFlacsDelegateRelation = (params) => {
  return axios.post(`${base}/extapi/flacsdelegaterelation/create`, params)
}

export const editFlacsDelegateRelation = (params) => {
  return axios.post(`${base}/extapi/flacsdelegaterelation/edit`, params)
}

export const deleteFlacsDelegateRelation = (id) => {
  return axios.post(`${base}/extapi/flacsdelegaterelation/delete`, null, { params: { id } })
}

// 飞白看板
export const flacs_dashboard_getdata = (params) => {
  return axios.post(`${base}/extapi/flacsdashboard/getdashboarddata`, params)
}

export const flacs_dashboard_getregionsalescascader = (params) => {
  return axios.get(`${base}/extapi/flacsdashboard/getregionsalescascader`, { params: params })
}

export const flacs_dashboard_getsalesoptions = (params) => {
  return axios.get(`${base}/extapi/flacsdashboard/getsalesoptions`, { params: params })
}

export const flacs_dashboard_gethospitaloptions = (params) => {
  return axios.get(`${base}/extapi/flacsdashboard/gethospitaloptions`, { params: params })
}

export const flacs_dashboard_getprovinceoptions = () => {
  return axios.get(`${base}/extapi/flacsdashboard/getprovinceoptions`)
}

// 飞白填报 - 按日填报
export const flacs_getDailyDataByDate = (params) => {
  return axios.get(`${base}/extapi/flacs/getdailydatabydate`, { params: params })
}

export const flacs_saveDailyData = (params) => {
  return axios.post(`${base}/extapi/flacs/savedailydata`, params)
}
